export const DICTIONARY = {
  DICTIONARY: 'dictionary',
  ACTIVE_DICTIONARIES: 'ACTIVE_DICTIONARIES',
  DICTIONARIES: 'DICTIONARIES',
  DICTIONARIES_HASH: 'DICTIONARIES_HASH',
};
